export default __webpack_public_path__ + "media/zurb/img/party/zurb-logo-44145094772564df19ead7b356a310cf.png";